import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export default function TokenRedirect() {
  const { token } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (token) {
      // Store token in cookie
      document.cookie = `token=${encodeURIComponent(token)}; path=/; max-age=31536000`;
      // Redirect to home
      navigate('/');
    }
  }, [token, navigate]);

  return null;
}
